import React from 'react';
import { useTranslation } from 'react-i18next';


const ConfirmRemoveDialog = ({ close, title, confirm }) => {
    const { t } = useTranslation();
  
    return (
      <div className="dialog">
        <div className="dialog-content">
          <div className="form-group">
            <label htmlFor="groupName">{title}</label>
          </div>
          <div className="form-container-actions">
            <div className="flex-end">
              <button className="button" onClick={() => close(false)}>
                {t('buttons.common.cancel')}
              </button>
              <button className="button button-delete" onClick={confirm}>
                {t('buttons.common.delete')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

export default ConfirmRemoveDialog